import NewCommonServiceHero from "../../../common/NewCommonServices/NewCommonServiceHero";
import NewCommonServiceForm from "../../../common/NewCommonServices/NewCommonServiceForm";
import NewCommonMoreItService from "../../../common/NewCommonServices/NewCommonMoreItService";
import {
  SoftwareAndSaasDevelopmentIcon,
  WebsiteAndAppDevelopmentIcon,
  cloudAndDevops,
  itSupportAndMaintainance,
  mobileAndAppDevelopment,
} from "../../../../assets/icons/serviceIcon/index";

const items = [
  {
    name: "Threat Detection & Prevention",
    text: " Cyber threats move fast, but we move faster. We spot risks before they become problems, keeping your systems secure and your business running without interruptions.",
  },
  {
    name: "Data Encryption & Privacy",
    text: "Your data should be locked up tight. We use powerful encryption and privacy measures to keep sensitive information safe, whether it’s stored, shared, or in transit.",
  },
  {
    name: "Compliance & Risk Management",
    text: "Navigating security regulations can be a headache, but we’ve got it covered. We ensure your business meets industry standards, minimizing risks and keeping everything compliant.",
  },
];

const otherService = [
  {
    icon: mobileAndAppDevelopment,
    name: "Mobile App Development",
    des: "We build apps that feel smooth, look great, and keep your users hooked.",
    path: "/mobile-app-development",
  },
  {
    icon: cloudAndDevops,
    name: "Cloud & DevOps Solutions",
    des: "No tech headaches - just fast, secure, and hassle-free cloud solutions.",
    path: "/cloud-devops-development",
  },
  {
    icon: SoftwareAndSaasDevelopmentIcon,
    name: "Software & SaaS Development",
    des: "Smart, scalable, and built for the long run - software that grows with you.",
    path: "/software-saas-development",
  },
  {
    icon: WebsiteAndAppDevelopmentIcon,
    name: "Website & App Development",
    des: "We build websites that tell stories, connect hearts and build brands.",
    path: "/web-app-development",
  },
  {
    icon: itSupportAndMaintainance,
    name: "IT Support & Maintenance",
    des: "Seamless IT services to protect and power your business growth.",
    path: "/it-support-maintenance",
  },
];

const CyberSecurityProtection = () => {
  return (
    <div>
      <NewCommonServiceHero
        heading="Cyber Security & Data"
        colorHeading="Protection"
        description="Your data is your most valuable asset, and we make sure it stays that way. With rock-solid security, real-time threat monitoring, and smart protection, your business stays safe and stress-free."
      />
      <NewCommonServiceForm
        title="Cyber Security & data Protection"
        items={items}
      />
      <NewCommonMoreItService items={otherService} />
    </div>
  );
};

export default CyberSecurityProtection;
